import type {SyllabusTerm} from "app/employee/state/syllabus/mutations";
import {DetailedProgress} from "app/employee/syllabus/DetailedProgress";
import {useTranslation} from "react-i18next";

interface Props {
  terms: SyllabusTerm[];
}

export const SyllabusPendingTermPlan = ({terms}: Props) => {
  const pendingPlans = terms
    .flatMap((t) => t.termPlans.map((tp) => ({term: t, termPlan: tp})))
    .filter((tp) => !tp.termPlan.completed);

  const {t} = useTranslation();
  if (pendingPlans.length > 0) {
    return <DetailedProgress plansWithTerm={pendingPlans} />;
  } else {
    return <h4>{t("syllabus.pending.no-pending-course", {defaultValue: "Няма текущо обучение"})}</h4>;
  }
};
